<div class="ao-root">
  <!-- Başlık -->
  <div class="ao-baslik">
    <button class="ao-nav" (click)="oncekiAy()">◀</button>
    <span class="ao-ay">📅 {{ AY[ay] }} {{ yil }}</span>
    <button class="ao-nav" (click)="sonrakiAy()">▶</button>
    <span class="ao-spacer"></span>
    <button class="ao-btn-csv" (click)="csvIndir()">📥 CSV</button>
    <button class="ao-btn-print" (click)="yazdir()">🖨️ Yazdır</button>
  </div>

  @if (yukleniyor) {
    <div class="ao-loading">Yükleniyor...</div>
  }

  @if (ozet && !yukleniyor) {
    <!-- Özet kartlar -->
    <div class="ao-ozet-grid">
      <div class="ao-ozet-item ao-oi-yesil">
        <span class="ao-oi-val">{{ dk2Str(ozet.toplamNormalDk) }}</span>
        <span class="ao-oi-lbl">Normal Mesai</span>
      </div>
      <div class="ao-ozet-item ao-oi-turuncu">
        <span class="ao-oi-val">{{ dk2Str(ozet.toplamFazlaMesaiDk) }}</span>
        <span class="ao-oi-lbl">Fazla Mesai</span>
      </div>
      <div class="ao-ozet-item">
        <span class="ao-oi-val">{{ ozet.calismaGunSayisi }}</span>
        <span class="ao-oi-lbl">Çalışılan Gün</span>
      </div>
      <div class="ao-ozet-item ao-oi-kirmizi">
        <span class="ao-oi-val">{{ ozet.devamsizGunSayisi }}</span>
        <span class="ao-oi-lbl">Devamsız</span>
      </div>
      <div class="ao-ozet-item ao-oi-mavi">
        <span class="ao-oi-val">{{ ozet.izinliGunSayisi + ozet.raporluGunSayisi }}</span>
        <span class="ao-oi-lbl">İzin/Rapor</span>
      </div>
      <div class="ao-ozet-item ao-oi-mor">
        <span class="ao-oi-val">{{ ozet.tatilGunSayisi }}</span>
        <span class="ao-oi-lbl">Tatil</span>
      </div>
    </div>

    <!-- Gün bazlı tablo -->
    <div class="ao-tablo-wrap" id="pdks-aylik-tablo">
      <table class="ao-tablo">
        <thead>
          <tr>
            <th>Gün</th>
            <th>Durum</th>
            <th>Kayıt</th>
            <th>Giriş</th>
            <th>Çıkış</th>
            <th>Mola</th>
            <th>Net</th>
            <th>F.Mesai</th>
            <th>Çarpan</th>
          </tr>
        </thead>
        <tbody>
          @for (g of ozet.gunler; track g.tarih) {
            <tr [class.ao-tr-tatil]="g.durum === 'tatil'" [class.ao-tr-devamsiz]="g.durum === 'devamsiz'"
                [class.ao-tr-izin]="g.durum === 'izinli' || g.durum === 'raporlu'"
                [class.ao-tr-haftasonu]="g.durum === 'calisma_gunu_degil'">
              <td class="ao-td-gun">
                <span class="ao-gun-no">{{ gunNo(g.tarih) }}</span>
                <span class="ao-gun-isim">{{ gunIsim(g.tarih) }}</span>
              </td>
              <td>
                <span class="ao-durum-chip" [style.background]="durumRenk(g.durum) + '18'" [style.color]="durumRenk(g.durum)">
                  {{ durumEtiket(g.durum) }}
                </span>
              </td>
              <td class="ao-td-kayit">{{ g.kayitlar.length > 0 ? g.kayitlar.length : '—' }}</td>
              <td class="ao-td-zaman">{{ ilkGiris(g) }}</td>
              <td class="ao-td-zaman">{{ sonCikis(g) }}</td>
              <td class="ao-td-dk">{{ g.toplamMolaDk > 0 ? dk2Str(g.toplamMolaDk) : '—' }}</td>
              <td class="ao-td-dk ao-td-bold">{{ g.toplamCalismaDk > 0 ? dk2Str(g.toplamCalismaDk) : '—' }}</td>
              <td class="ao-td-dk" [class.ao-td-fazla]="g.fazlaMesaiDk > 0">{{ g.fazlaMesaiDk > 0 ? dk2Str(g.fazlaMesaiDk) : '—' }}</td>
              <td class="ao-td-carpan" [style.color]="g.mesaiCarpani > 1 ? '#fa8c16' : '#999'">×{{ g.mesaiCarpani }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
